import { unflatten } from 'flat'

import {
  Department,
  DepartmentApi,
  DepartmentFormData,
  DepartmentFormDataApi,
  DepartmentFormErrors,
  DepartmentFormErrorsApi,
  DepartmentSelect,
  DepartmentSelectApi,
} from '../types'
import { formDataFlat } from '@shared/utils/form-data-flat'

export class DepartmentMappers {
  public static fromApi(department: DepartmentApi): Department {
    return {
      id: department.id,
      departmentName: department.department_name,
      departmentCode: department.department_code,
      description: department.descr ?? '',
      state: {
        id: department.state?.id ?? '',
        state_name: department.state?.state_name ?? '',
        descr: department.state?.descr ?? '',
      },
      warehouses: department.warehouses,
      warehousesCount: department.warehouses?.length ?? 0,
      createdAt: department.created_at,
    }
  }

  public static manyFromApi(raw: DepartmentApi[]): Department[] {
    return raw.map((item) => this.fromApi(item))
  }

  public static fromSelectApi(department: DepartmentSelectApi): DepartmentSelect {
    return {
      id: department.id,
      name: department.department_name,
    }
  }

  public static manyFromSelectApi(raw: DepartmentSelectApi[]): DepartmentSelect[] {
    return raw.map((item) => this.fromSelectApi(item))
  }

  public static formDataToApi(formData: DepartmentFormData): DepartmentFormDataApi {
    return formDataFlat({
      id: formData.id,
      department_name: formData.departmentName,
      department_code: formData.departmentCode,
      state_id: formData.stateId,
      descr: formData.descr,
    })
  }

  public static formErrorsFromApi(errors: DepartmentFormErrorsApi): DepartmentFormErrors {
    const unFlatten: Record<string, string[]> = unflatten(errors) as Record<string, string[]>

    return {
      id: unFlatten.id?.join(', '),
      departmentCode: unFlatten.department_code?.join(', '),
      departmentName: unFlatten.department_name?.join(', '),
      stateId: unFlatten.state_id?.join(', '),
      descr: unFlatten.descr?.join(', '),
    }
  }

  public static formInitializer(department: Department): DepartmentFormData {
    return {
      id: department.id.toString(),
      departmentName: department.departmentName,
      departmentCode: department.departmentCode,
      stateId: department.state?.id?.toString(),
      descr: department.description ?? null,
    }
  }
}
